import React from "react";
import { Button, Modal } from "@hid-galaxy-ui/galaxy-react";
import ScreenshotMedia from "./ScreenshotMedia";
import { ScreenshotItem } from "./screenshotsConfig";
import "./ScreenshotModals.scss";

type RemoveScreenshotModalProps = {
  screenshot: ScreenshotItem;
  isRemoving?: boolean;
  errorMessage?: string | null;
  onCancel: () => void;
  onConfirm: () => void;
};

const WarningIcon: React.FC = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <path d="M12 9v4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    <circle cx="12" cy="17" r="1" fill="currentColor" />
  </svg>
);

const RemoveScreenshotModal: React.FC<RemoveScreenshotModalProps> = ({
  screenshot,
  isRemoving = false,
  errorMessage = null,
  onCancel,
  onConfirm,
}) => (
  <Modal
    width={420}
    isDisplayCloseIcon={false}
    onClose={() => {
      if (!isRemoving) onCancel();
    }}
    className="screenshot-remove-modal"
  >
    <div className="screenshot-remove-modal__content">
      <span className="screenshot-remove-modal__icon">
        <WarningIcon />
      </span>
      <h3 className="screenshot-remove-modal__title">Remove Screenshot</h3>
      <p className="screenshot-remove-modal__message">
        Are you sure you want to remove this screenshot? This action cannot be
        undone.
      </p>
      <div className="screenshot-remove-modal__preview">
        <ScreenshotMedia
          url={screenshot.url}
          name={screenshot.name}
          mimeType={screenshot.mimeType}
        />
      </div>
      {errorMessage ? (
        <p className="screenshots-modal__error">{errorMessage}</p>
      ) : null}
    </div>
    <div className="screenshot-remove-modal__actions">
      <button
        type="button"
        className="screenshots-modal__btn screenshots-modal__btn--secondary"
        onClick={onCancel}
        disabled={isRemoving}
      >
        Cancel
      </button>
      <Button
        variant="primary"
        label={isRemoving ? "Removing..." : "Remove"}
        className="screenshots-modal__upload-btn"
        disabled={isRemoving}
        onClick={onConfirm}
      />
    </div>
  </Modal>
);

export default RemoveScreenshotModal;
